import { render, staticRenderFns } from "./Sections.vue?vue&type=template&id=2d1f2cde&scoped=true&"
import script from "./Sections.vue?vue&type=script&lang=js&"
export * from "./Sections.vue?vue&type=script&lang=js&"
import style0 from "./Sections.vue?vue&type=style&index=0&id=2d1f2cde&lang=scss&scoped=true&"
import style1 from "./Sections.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1f2cde",
  null
  
)

export default component.exports